import React from 'react';

import { Pages } from '@/pages';
import type { AppRouteObject } from '@/routeTypes';

const SubsidyRecipients = React.lazy(
  () => import('@/pages/SubsidiesAndBenefits/views/SubsidyRecipients'),
);
const InDevelopment = React.lazy(
  () => import('@/pages/SubsidiesAndBenefits/views/InDevelopment'),
);

export const subsidiesAndBenefitsRoutes: AppRouteObject[] = [
  { index: true, element: <SubsidyRecipients /> },
  { path: Pages.BENEFICIARIES, element: <InDevelopment /> },
  { path: Pages.UNDISTRIBUTED, element: <InDevelopment /> },
  { path: Pages.HISTORY, element: <InDevelopment /> },
];
